<template>
    <main class="p-6">
        <h1>Redirecting to secure registration…</h1>
        <p v-if="message" class="error-message">{{ message }}</p>
    </main>
</template>


<script>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { generateRegistrationUrl } from '@/utils/RegisterReferralHelper.js';
import { checkAuthentication } from '@/api/auth'
export default {
    name: 'ReferralView',
    setup() {
        const route = useRoute();
        const message = ref('');

        onMounted(async () => {
            try {
                const { isAuthenticated } = checkAuthentication();
                if (isAuthenticated) {
                    message.value = 'You have already login. If you want to register a new account, please logout first.';
                    setTimeout(() => {
                        window.location.replace('/');
                    }, 3000);
                    return;
                }
                let refCode = (route.query.ref || '').toString().trim();

                if (refCode) sessionStorage.setItem('referral_code', refCode);

                const kcUrl = await generateRegistrationUrl(refCode);
                console.log(refCode);
                console.log(kcUrl);
                window.location.replace(kcUrl);
            } catch (e) {
                console.error('Failed to build registration URL', e);
                message.value = 'Unable to start registration. Please try again.';
                setTimeout(() => {
                    window.location.replace('/');
                }, 3000);
            }
        });
        return { message }
    }
}
</script>

<style scoped>
.error-message {
    color: red;
    font-weight: bold;
    background-color: #ffe6e6;
    padding: 10px;
    border: 1px solid red;
    border-radius: 4px;
}
</style>